import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [

  {
    path: '/',
    name: 'Search',
    component: () => import('../views/search/index'),
    meta: {
      title: '检索环境数据-绿网'
    }
  },

  // 放在最后
  {
    path: '/404',
    name: '404',
    component: () => import('../views/error/404'),
    meta: {
      title: '404'
    }
  },
  {
    path: '*',
    redirect: '/404'
  }

]

// add route path
// routes.forEach(route => {
//   route.path = route.path || '/' + (route.name || '')
// })

const router = new Router({
  // mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  next()
})

export {
  router
}



// WEBPACK FOOTER //
// ./src/router/index.js